import { ColorOptions } from "@/src/types";
import { StyledMainSection } from "@/styles/global";
import { Link } from "gatsby";
import { GatsbyImage } from "gatsby-plugin-image";
import styled, { css } from "styled-components";

type BackgroundProps = {
  $backgroundColor: ColorOptions;
};

const Section = styled(StyledMainSection)``;

const SwiperContainer = styled.div`
  .swiper-pagination-bullet {
    background-color: ${({ theme }) => theme.colors.orange};
  }
`;

const ScrollContainer = styled.div`
  overflow: scroll;
  padding: 0px 16px;
  scroll-behavior: smooth;
  -ms-overflow-style: none;
  scrollbar-width: none;

  &::-webkit-scrollbar {
    display: none;
  }

  @media screen and (min-width: ${({ theme }) => theme.breakpoints.lg}) {
    padding: 0 88px;
    scroll-snap-type: x mandatory;
    scroll-padding-left: 8px;
  }

  @media screen and (min-width: 1512px) {
    padding: 0 calc(50vw - 756px + 88px);
  }
`;

const Container = styled.div`
  display: flex;
  gap: 24px;
  width: max-content;
`;

const Image = styled(GatsbyImage)`
  position: relative;
  width: 100%;
  height: 220px;
  min-height: 220px;
  transition: all 0.2s ease-in-out;
  z-index: 1;
  overflow: hidden;
`;

const TextWrapper = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  width: 100%;
  padding: 16px 24px;
  justify-content: space-between;

  p {
    overflow: hidden;
    display: -webkit-box;
    line-clamp: 3;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
  }
`;

const CardWrapper = styled.div`
  border-radius: 14px;
  -webkit-border-radius: 14px;
  -moz-border-radius: 14px;
  overflow: hidden;
  transform: translateZ(0);
`;

const CardCss = css`
  position: relative;
  display: flex;
  flex-direction: column;
  width: 308px;
  /* height: 385px; */
  height: 100%;
  text-decoration: none;
  scroll-snap-align: start;
  background-color: ${({ theme }) => theme.colors.black};

  @media screen and (min-width: ${({ theme }) => theme.breakpoints.xl}) {
    cursor: pointer;
    /* height: 395px; */

    ${Image} {
      img {
        transition: all 0.2s ease-in-out;
      }
    }

    &:hover {
      ${Image} {
        img {
          transform: scale(1.04);
        }
      }
    }
  }
`;

const Card = styled(Link)`
  ${CardCss}
`;

const CardA = styled.a`
  ${CardCss}

  svg {
    transform: rotate(-45deg);
  }
`;

const Wrapper = styled.div<BackgroundProps>`
  background-color: ${({ theme, $backgroundColor }) =>
    theme.colors[$backgroundColor]};
  padding: 40px 0;

  @media screen and (min-width: ${({ theme }) => theme.breakpoints.lg}) {
    padding: 88px 0;
  }

  //if $backgroundColor is equal to "black" then apply the following styles
  ${({ $backgroundColor, theme }) =>
    $backgroundColor === "black" &&
    `
    h3 {
      color: ${theme.colors.creme};
    }
      svg {
        color: ${theme.colors.creme};
      }
    ${Card}, ${CardA} {
      background-color:  ${theme.colors.creme};
      ${TextWrapper} {

        p {
          color: ${theme.colors.black};
        }
      }
    }
  `}

  ${({ $backgroundColor, theme }) =>
    $backgroundColor === "brown" || $backgroundColor === "red"
      ? `
  h3 {
    color: ${theme.colors.creme};
  `
      : null}
`;

const Button = styled.div`
  width: 100%;
  border: none;
  padding: 4px 0;
  text-decoration: none;
  border-radius: 5px;
  -webkit-border-radius: 5px;
  -moz-border-radius: 5px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  margin-top: 32px;

  @media screen and (min-width: ${({ theme }) => theme.breakpoints.lg}) {
    p {
      transition: all 0.2s ease-in-out;
    }

    &:hover {
      p {
        opacity: 0.6;
      }
    }
  }
`;

const S = {
  Section,
  SwiperContainer,
  ScrollContainer,
  Container,
  Image,
  TextWrapper,
  CardWrapper,
  Card,
  CardA,
  Wrapper,
  Button,
};

export default S;
